import { soldListingsApi } from "../store/api/soldListingsApi";
import { runQuery } from "../store/api/runtime";

export const getSoldListings = async (
  input: string | { cardName?: string; game?: string; cardId?: string }
): Promise<unknown> => runQuery(soldListingsApi.endpoints.getSoldListings.initiate, input);
